<template>
  <div style="width: 100%; height: 100%" id="projectScheduleChart"></div>
</template>

<script>
import * as echarts from "echarts";
import { ajax } from "@/config/ppm-request.js";
export default {
  name: "project-schedule-chart",
  data() {
    return {
      projectScheduleChart: null,
    };
  },
  mounted() {
    this.projectScheduleChart = echarts.init(
      document.getElementById("projectScheduleChart")
    );
    ajax.get("/zsck/bi/getProjectCountByState").then((res) => {
      const keys = Object.keys(res);
      const values = [];
      let colors = ["#104f94", "#3077ac", "#484a98", "#6e79a3", "#3eb4a1", "#d6765b"];
      const useColors = [];
      keys.forEach((item, index) => {
        values.push(res[item]);
        useColors.push(colors[index] || this.getRandomHexColor());
      });
      this.projectScheduleChart.setOption({
        xAxis: {
          type: "category",
          // axisLabel: {
          //   color: "#ccc", // 设置字体颜色为
          //   fontSize: "0.6rem",
          //   formatter: '{value} 单位'
          // },
          axisLine: {
            lineStyle: {
              color: "#293b52", // X轴线的颜色
            },
          },
          splitLine: {
            lineStyle: {
              color: "#293b52", // 设置分割线颜色
            },
          },
          axisTick: {
            show: false, // 显示刻度线
            alignWithLabel: true, // 刻度线与标签对齐
            lineStyle: {
              color: "#293b52", // X轴刻度线的颜色
            },
          },
        },
        yAxis: {
          type: "value",
          name: "(个)",
          nameTextStyle: {
            color: "#8a92ad",
          },
          axisLabel: {
            color: "#8a92ad",
            align: "right",
          },
          min: 0,
          splitNumber: 6,
          splitLine: {
            lineStyle: {
              color: "#293b52", // 设置分割线颜色
            },
          },
          // interval: 200,
        },
        grid: {
          left: 20,
          right: "6%",
          bottom: "8%",
          top: "10%",
          containLabel: true,
        },
        color: [...useColors],
        legend: {
          textStyle: {
            color: "#ccc", // 设置图例文字颜色
            fontSize: "0.8rem",
          },
          x: "center",
          y: "bottom",
          icon: "circle",
          itemHeight: 10,
          itemWidth: 10,
          data: [...keys],
        },
        series: values.map((item, index) => {
          return {
            name: keys[index],
            data: [item],
            type: "bar",
            label: {
              show: true, // 显示标签
              position: "top", // 标签的位置，这里是顶部
              textStyle: {
                color: useColors[index],
                fontSize: "1rem",
              },
            },
          };
        }),
        // [
        //   {
        //     name: "立项",
        //     data: [res.projectApproval],
        //     type: "bar",
        //     label: {
        //       show: true, // 显示标签
        //       position: "top", // 标签的位置，这里是顶部
        //       textStyle: {
        //         color: "#104f94",
        //         fontSize: "1rem",
        //       },
        //     },
        //   },
        //   {
        //     name: "正常",
        //     data: [res.normal],
        //     type: "bar",
        //     label: {
        //       show: true, // 显示标签
        //       position: "top", // 标签的位置，这里是顶部
        //       textStyle: {
        //         color: "#3077ac",
        //         fontSize: "1rem",
        //       },
        //     },
        //   },
        //   {
        //     name: "超额完成",
        //     data: [res.exceed],
        //     type: "bar",
        //     label: {
        //       show: true, // 显示标签
        //       position: "top", // 标签的位置，这里是顶部
        //       textStyle: {
        //         color: "#484a98",
        //         fontSize: "1rem",
        //       },
        //     },
        //   },
        //   {
        //     name: "逾期",
        //     data: [res.beOverdue],
        //     type: "bar",
        //     label: {
        //       show: true, // 显示标签
        //       position: "top", // 标签的位置，这里是顶部
        //       textStyle: {
        //         color: "#6e79a3",
        //         fontSize: "1rem",
        //       },
        //     },
        //   },
        // ]
      });
    });
  },
  methods: {
    getRandomHexColor() {
      return '#' + (Math.random() * 0x1000000 << 0).toString(16).padStart(6, '0');
    }
  }
};
</script>

<style>
</style>